import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import ProfileSubAdmins from "models/profile.modal"
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import SupportTickets from "models/supportticket.modal";

const Addticket = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [datalist,setDatalist] = useState();
  const navigate = useNavigate();
  const parms = useParams();
  const location = useLocation();
  // Check if the current route matches the desired route path

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);

    SupportTickets.Add(form)
      .then((response) => {
        helper.sweetalert.toast("Your Ticket add.", "success");

        setAddsLoadig(false);
        navigate("/admin/supportticket");
      })
      .catch((error) => {
        setAddsLoadig(false);
        console.log("error",error)
        helper.sweetalert.toast(error.response?.data?.message, "warning");
        // console.log(error);
      });
  };

  const userlist =async()=>{
    ProfileSubAdmins.Getlist()
    .then((responce)=>{
      setDatalist(responce?.data?.data)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  useEffect(()=>{
userlist();
  },[])
  
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  <span>Create New Ticket</span>
                </h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label> Subject </Label>
                          <Input name="subject" placeholder="Enter Name" />
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label> Contact no </Label>
                          <Input
                            name="parent_id"
                            placeholder="Enter Contact no"
                            type="select"
                            defaultValue={parms?.id}
                          >
                            {datalist?.map((item,index)=>{
                              return(
                                <option value={item?.username}>{item?.first_name}{" "}{item?.last_name}{" "}{`(${item?.
                                  username})`}</option>
                                
                              )
                            })}
                           
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={12}>
                        <FormGroup>
                          <Label>Message</Label>
                          <Input
                            name="complaint"
                            type="textarea"
                            placeholder="Enter Description"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Priority</Label>
                          <Input name="priority" type="select">
                            <option value="">Select Option</option>
                            <option value="High">High</option>
                            <option value="Medium">Medium</option>
                            <option value="Low">Low</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label> Upload ScreenShot(1)</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="image1"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label> Upload ScreenShot(2)</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            name="image2"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label> Upload ScreenShot(3)</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            name="image3"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Support Type </Label>
                          <Input name="support_type" type="select">
                            <option value="">Select Option</option>
                            <option value="Attendance">Attendance</option>
                            <option value="Account">Account</option>
                            <option value="Payment">Payment</option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Support Related to </Label>
                          <Input name="support_related_to" type="select">
                            <option value="">Select Option</option>
                            <option value="student/Parent">student/Parent</option>
                            <option value="Tutor">Tutor</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Status </Label>
                          <Input name="status" type="select">
                            <option value="New">New</option>
                            <option value="Working">Working</option>
                            <option value="Resolved">Resolved</option>
                            
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label>Remark </Label>
                          <Input name="remark" type="textarea" placeholder="Enter your remark">
                            
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        color="secondary"
                        onClick={() => {
                          navigate("/admin/supportticket");
                        }}
                      >
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{
                            float: "right",
                            marginLeft: "5%",
                            backgroundColor: "#080278",
                            color: "white",
                            border: "none",
                          }}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Addticket;
